export default {
  SET_STATISTICS_MIZ_343(state, payload) {
    state.statistics_miz_343 = payload;
  },
  SET_MAKSAM_MONITORING_OF_OBJECTS(state, payload) {
    state.maksam_monitoring_of_objects = payload;
  },
  SET_MAKSAM_POLLUTION_STATS(state, payload) {
    state.maksam_pollution_stats = payload;
  },

  SET_STATISTICS(state, data) {
    state.statistics = data
  },

  SET_STATISTICS_REPORT(state, data) {
    state.statisticsReport = data
  },

  SET_STATISTICS_REPORT_MIZ(state, data) {
    state.statisticsReportmiz = data
  }
};
